/* global document:false */
import {
  createStore, applyMiddleware, compose as defaultCompose,
} from 'redux';
import promiseMiddleware from 'redux-promise-middleware';
import rootReducer from './reducers';
import rejectedPromiseMiddleware from './middlewares/rejectedPromise';
import carouselMiddleware from './middlewares/carousel';
import contentMiddleware from './middlewares/content';
import productsMiddleware from './middlewares/products';
import layoutMiddleware from './middlewares/layout';
import trackingMiddleware from './middlewares/tracking';
import accountMiddleware from './middlewares/account';
import wishlistMiddleware from './middlewares/wishlist';
import editionMiddleware from './middlewares/edition';
import storiesMiddleware from './middlewares/stories';
import countdownMiddleware from './middlewares/countdown';
import waitlistMiddleware from './middlewares/waitlist';
import greenhouseMiddleware from './middlewares/greenhouse';
import favouritedBrandsMiddleware from './middlewares/favouritedBrands';
import sponsoredBrandsMiddleware from './middlewares/sponsoredBrands';
import { getContentId } from './selectors';

function getDevToolsName(preloadedState) {
  if (preloadedState) {
    const uid = getContentId(preloadedState);
    if (uid) {
      return `THE ICONIC :: ${uid}`;
    }
  }
  return document.title;
}

function selectComposeFunction(preloadedState) {
  /* global __REDUX_DEVTOOLS_EXTENSION_COMPOSE__:false */
  if (typeof __REDUX_DEVTOOLS_EXTENSION_COMPOSE__ === 'function') {
    // if you install the Redux Devtools extension (see https://github.com/zalmoxisus/redux-devtools-extension)
    // then this will connect to the dev tools and allow you to inspect Redux state
    return __REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      name: getDevToolsName(preloadedState),
    });
  }
  return defaultCompose;
}

export default function (preloadedState) {
  const compose = selectComposeFunction(preloadedState);
  const enhancers = compose(applyMiddleware(
    rejectedPromiseMiddleware,
    promiseMiddleware(),
    carouselMiddleware,
    contentMiddleware,
    productsMiddleware,
    layoutMiddleware,
    trackingMiddleware,
    accountMiddleware,
    wishlistMiddleware,
    editionMiddleware,
    storiesMiddleware,
    countdownMiddleware,
    waitlistMiddleware,
    greenhouseMiddleware,
    favouritedBrandsMiddleware,
    sponsoredBrandsMiddleware,
  ));

  const store = createStore(rootReducer, preloadedState, enhancers);

  /* istanbul ignore next: exclude HMR code path from test coverage calculations */
  if (module.hot && process.env.NODE_ENV === 'development') {
    module.hot.accept('./reducers/index', () => {
      // eslint-disable-next-line global-require
      const nextRootReducer = require('./reducers/index');
      store.replaceReducer(nextRootReducer);
    });
  }

  return store;
}
